export const testimonials = [
  {
    id: 'test-1',
    name: 'Sarah Miller',
    role: 'Design Studio Owner',
    avatar: 'https://i.pravatar.cc/150?u=sarah',
    content: 'Motion Grid Pro completely transformed how we build landing pages for clients. The animation presets alone saved us hundreds of hours. Our clients consistently praise the smooth, professional feel.',
    rating: 5,
    product: 'Motion Grid Pro',
  },
  {
    id: 'test-2',
    name: 'James Chen',
    role: 'Web Agency Director',
    avatar: 'https://i.pravatar.cc/150?u=james',
    content: 'The Loop Grid Filters addon is a game changer for e-commerce sites. Our clients can now filter products instantly without page reloads. Support is incredibly responsive too.',
    rating: 5,
    product: 'Loop Grid Filters',
  },
  {
    id: 'test-3',
    name: 'Maria Rodriguez',
    role: 'Freelance Developer',
    avatar: 'https://i.pravatar.cc/150?u=maria',
    content: 'I have been using Motionsdio products for two years now. The license management is straightforward, updates are frequent, and the documentation is excellent. Highly recommended.',
    rating: 5,
    product: 'Motion Portfolio Theme',
  },
  {
    id: 'test-4',
    name: 'David Kim',
    role: 'Tech Startup CTO',
    avatar: 'https://i.pravatar.cc/150?u=david',
    content: 'The Elementor Starter Kit helped us ship our marketing site in under a week. The blocks are well-designed and the code is clean. Worth every penny.',
    rating: 4,
    product: 'Elementor Starter Kit',
  },
  {
    id: 'test-5',
    name: 'Emily Watson',
    role: 'UI/UX Designer',
    avatar: 'https://i.pravatar.cc/150?u=emily',
    content: 'Motion Icon Library is my go-to for any project needing animated icons. The Lottie format makes integration seamless, and the variety is impressive.',
    rating: 5,
    product: 'Motion Icon Library',
  },
  {
    id: 'test-6',
    name: 'Robert Taylor',
    role: 'WordPress Consultant',
    avatar: 'https://i.pravatar.cc/150?u=robert',
    content: 'The license system is robust and the activation API is well documented. I have integrated Motion products into dozens of client sites with zero issues.',
    rating: 5,
    product: 'Motion Forms Builder',
  },
];